const VehiclePage = (() => {
    const getEcommerceData = () => {
        return typeof dataLayerEcommerceData === "object" ? dataLayerEcommerceData : undefined;
    }
    
    const triggerEvent = (eventName, ecommerceAmends = () => {}) => {
        const ecommerceData = getEcommerceData();
        
        if (!ecommerceData) {
            return;
        }
        
        if (typeof  ecommerceAmends === "function") {
            ecommerceAmends(ecommerceData);    
        }        
        
        DataLayerManager.trigger(eventName, ecommerceData);
    }
    
    const bindViewEvent = () => {
        const ecommerceData = getEcommerceData();

        if (!ecommerceData) {
            return;
        }
        
        const productId = ecommerceData.items[0].item_id;
        
        if (sessionStorage.getItem("viewedProduct") !== productId) {
            triggerEvent(DataLayerManager.events.viewItem);
            
            sessionStorage.setItem("viewedProduct", productId);            
        }
    }
    
    const bindBeginCheckout = () => {
        const businessEnquiryOption = document.querySelector("[data-field-name='natureOfEnquiry'] [value='Business']");
        
        if (businessEnquiryOption) {
            businessEnquiryOption.addEventListener("change", () => {
                triggerEvent(DataLayerManager.events.beginCheckout);
            });
        }
    }
    
    const bindAddToCart = () => {
        const enquireButton = document.querySelector("[data-enquire-now]");
        
        if (enquireButton) {
            enquireButton.addEventListener("click", () => {
                triggerEvent(DataLayerManager.events.addToCart);
            });
        }
    }
    
    const bindAddPaymentInfo = () => {
        const formStepField = document.querySelector("[name='FormStep'][value='1']");
        const form = formStepField?.closest("form");
        
        if (!form) {
            return;
        }
        
        form.addEventListener("submit", () => {
            const previousClickedField = document.querySelector("[name='PreviousClicked']");
            const fleetField = document.querySelector("[data-field-name='howManyVehiclesDoYouNeed']");
            
            if (previousClickedField.value !== "clicked") {
                triggerEvent(DataLayerManager.events.addPaymentInfo, ecommerceModel => {
                    ecommerceModel.items[0].quantity = parseInt(fleetField.value);
                });
            }
        });
    }

    const bindAddShippingInfo = () => {
        const formStepField = document.querySelector("[name='FormStep'][value='0']");
        const form = formStepField?.closest("form");

        if (!form) {
            return;
        }

        form.addEventListener("submit", () => {
            const previousClickedField = document.querySelector("[name='PreviousClicked']");

            if (previousClickedField.value !== "clicked") {
                triggerEvent(DataLayerManager.events.addShippingInfo);
            }
        });
    }
    
    const init = () => {
        bindViewEvent();
        bindBeginCheckout();
        bindAddToCart();
        bindAddPaymentInfo();
        bindAddShippingInfo();
    }
    
    return { init };
})();

document.addEventListener("DOMContentLoaded", () => {
    VehiclePage.init();
});